export default __webpack_public_path__ + "static/media/bigHashtag-icon.d571df1e.svg";